import ReasonView from 'src/components/ui/ReasonView';
import { DIRECTION } from '../constants';

import CallHistory from '../CallHistory';

export default {
	title: 'Components/CallHistory',
	component: CallHistory,
	parameters: {},
	tags: ['autodocs'],
	args: {},
};

export const StoryCallHistoryPrimary = {
	name: 'Primary',
	args: {
		duration: '18:09',
		topContent: (
			<ReasonView
				date="29.06.2023 09:03"
				from="Леви Томас"
				to="Говнова Ольга (Директор)"
			/>
		),
		player: {
			source: '/assets/medias/sample-3s.wav',
		},
		details: [
			{
				id: 'details',
				params: [
					{ id: 1, label: 'Тип', value: 'Исходящий' },
					{ id: 2, label: 'С номера', value: '+7 (917) 209-77-87' },
					{ id: 3, label: 'На номер', value: '+7 (906) 919-35-37' },
					{ id: 4, label: 'Отвечено', value: '17 сек' },
					{ id: 5, label: 'Разговор', value: '43 сек' },
					{ id: 6, label: 'Звонок', value: '26 сек' },
					{ id: 7, label: 'Разрыв', value: 'Caller' },
				],
			},
			{
				id: 'transcription',
				text: 'Купил года с 2 назад белый ковер в кабинет себе. Ну как кабинет... кабинетик. Диван, пару столиков, стул, квадратов на 8 всего помещеньице. Стены белые, мебель тёмная, ну решил "поиграть с цветами" и кинуть на пол белый ковер). Брал не дорого - что-то вроде пару тыщ. Думаю, ну не пойдёт - не жалко потом и на дачу отвезти. В итоге, не смотря на то, что коврик полипропиленовый и длинноворсовый, ничо с ним за пару лет и не случилось особо. И это учитывая "забывчивость" - не совсем чистая обувь с улицы и по ковру за ключами). Ну и пару раз на него лилось и сыпалось всякое) Отмывается на раз, не потемнел, не выцвел, пятен невыводимых нет. Так что, дамы и господа - не бойтесь белых ковров! Современная химчистка отмоет всё, а если не позволяет деньга - всевозможные Ванишы тоже решают проблему загрязнения светлого текстиля на раз-два. Всем удачки! Когда он пришел, мне так понравился по качеству и внешнему виду, что приняла решение приобрести сразу и второй, для туалета. Он у меня выполнен в серых оттенках, соответственно и коврик выбрала - серый.',
			},
		],
		links: {
			actions: [
				{ id: 'details', label: 'Детали звонка' },
				{ id: 'transcription', label: 'Транскрипция' },
				{ id: 'log', label: 'Лог' },
				{ id: 'download', label: 'Скачать' },
			],
		},
	},
};

export const StoryCallHistoryIncomingExpanded = {
	name: 'Incoming Expanded',
	args: {
		...StoryCallHistoryPrimary.args,
		details: undefined,
		expanded: true,
		direction: DIRECTION.incoming,
	},
};
